import { DataTable } from "@msuite/ui/table";
import { useTransportOrders } from "@/hooks/use-transport-orders";
import type { TransferCarrierPanelBaseProps } from "../shared";
import { columns } from "./table-config";

/**
 * Every put-away this trolley has carried, newest first.
 *
 * The scope is deliberately unset: a carrier's page asks what it has done, not what is waiting, so
 * finished and cancelled legs belong here as much as open ones. That is the whole history a
 * transfer carrier has — it holds no stock and keeps no ledger, so what it carried is the only
 * account of its working life.
 */
export function TransferCarrierHistory({ transferCarrierId }: TransferCarrierPanelBaseProps) {
	/** Hooks */
	const { transportOrders, isLoading, queryKey, refetch } = useTransportOrders({
		scope: "all",
		transferCarrierId,
	});

	/** Render */
	return (
		<DataTable
			data={transportOrders}
			columns={columns}
			isLoading={isLoading}
			refetch={refetch}
			queryKey={queryKey}
			persistenceKey="data-transfer-carrier-history-table"
			menu={null}
			variant="table"
		/>
	);
}
